import { memo, useCallback, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { AddLocation } from "@coworker/apprestructured/src/task-management/components/AddLocation/AddLocation";
import { useFilteredLocations } from "@coworker/apprestructured/src/task-management/services/useLocations";

function AddLocationDemo() {
  const [disabled, setDisabled] = useState(false);
  const [slid, setSlid] = useState("");
  const [customLocation, setCustomLocation] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const itemNoAndType = { no: "70466811", type: "ART" };

  const {
    filteredLocations,
    isLoadingLocations,
    totalAssignedSalesSpaceQuantity,
  } = useFilteredLocations(itemNoAndType, searchQuery);

  const handleConfirmClick = useCallback(
    ({ slid, customLocation }: { slid?: string; customLocation?: string }) => {
      setSlid(slid ?? "");
      setCustomLocation(customLocation ?? "");
    },
    []
  );

  const handleTabChanged = useCallback(() => {}, []);

  return (
    <Demo>
      <Name>AddLocation</Name>
      <Highlight>
        <FixaListView id="addlocationdemo" size="small">
          <AddLocation
            onTabChanged={handleTabChanged}
            itemNoAndType={itemNoAndType}
            slid={slid}
            customLocation={customLocation}
            disabled={disabled}
            onConfirmClick={handleConfirmClick}
            isLoadingLocations={isLoadingLocations}
            filteredLocations={filteredLocations}
            totalAssignedSalesSpaceQuantity={totalAssignedSalesSpaceQuantity}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="addlocationdemo-disabled"
          id="addlocationdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AddLocationDemo);
